import { joinKeys } from 'helpers/translations.helper';
import { prefix } from '../../constants';

export const translationPrefix = joinKeys(prefix, 'modals.deleteResults');
